import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { Declaration, DeclarationGoods, RecursivePartial } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

interface HookProps {
  lrn: string;
  sequence: number;
  partialDeclaration: RecursivePartial<Declaration>;
  partialGoodsShipmentItem?: RecursivePartial<DeclarationGoods>;
  storeSavedDeclaration?: boolean;
}

export const useUpdateDeclarationDataLrn = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ lrn, sequence, partialDeclaration, partialGoodsShipmentItem, storeSavedDeclaration = true }: HookProps) => {
      return request({
        path: `declarations/${lrn}/save-declaration-data-lrn`,
        method: 'PATCH',
        authenticate: true,
        dataObject: { lrn, sequence, partialDeclaration, partialGoodsShipmentItem },
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['declaration'] });
      toast.success('Declaration updated!');
    },
    onError: (error) => {
      showErrorToast(error, `Error updating the declaration!`);
    },
  });
};
